var _rect, _g, _rect2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 30,
    fill: "url(#paint0_linear_24_14)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_24_14)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.0655,
    y: 50,
    width: 68.1223,
    height: 42.5764,
    rx: 21.2882,
    fill: "url(#paint1_linear_24_14)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12.9999,
    width: 73.7991,
    height: 73.7991,
    rx: 30,
    fill: "url(#paint2_linear_24_14)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_14)",
    filter: "url(#filter1_i_24_14)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_24_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.2276 70.8203C67.2522 69.6517 69.6434 67.2605 70.812 64.2358C71.3652 62.8031 71.7524 61.1684 71.8576 58.7772C71.8824 58.217 71.9018 57.7468 71.9198 57.2752V41.2988C71.9073 40.9655 71.8935 40.6184 71.8755 40.2284C71.7704 37.8372 71.3832 36.1942 70.83 34.7697C70.2588 33.2581 69.3792 31.9041 68.2286 30.7797C67.1028 29.636 65.7406 28.7481 64.2455 28.1866C62.8127 27.6334 61.178 27.2462 58.7868 27.1411C56.3776 27.0263 55.6129 27 49.5041 27C43.3954 27 42.6293 27.0263 40.2298 27.1314C37.8386 27.2365 36.1956 27.6237 34.7711 28.1769C33.2594 28.7481 31.9055 29.6277 30.7797 30.7797C29.6374 31.9055 28.7495 33.2678 28.1866 34.7614C27.6334 36.1942 27.2462 37.8289 27.1411 40.2201C27.0263 42.6293 27 43.3941 27 49.5042C27 55.6142 27.0263 56.379 27.1314 58.7785C27.2365 61.1697 27.6237 62.8141 28.1783 64.2372C28.7495 65.7488 29.6374 67.1028 30.7797 68.2286C31.9055 69.3709 33.2677 70.2602 34.7628 70.8217C36.1956 71.3749 37.8303 71.7621 40.2215 71.8672C42.621 71.9737 43.3858 72 49.4958 72C55.6059 72 56.3694 71.9737 58.7702 71.8672C61.1614 71.7621 62.8045 71.3749 64.2289 70.8217L64.2276 70.8203ZM49.5124 67.9547C43.5075 67.9547 42.7869 67.9285 40.422 67.8233C38.2244 67.7265 37.0378 67.3573 36.2467 67.0503C35.2717 66.6893 34.3838 66.1181 33.6619 65.3713C32.9151 64.6411 32.3425 63.7629 31.9829 62.7865C31.6759 61.9954 31.3067 60.7991 31.2098 58.6112C31.1047 56.238 31.0785 55.5257 31.0785 49.5208C31.0785 43.5158 31.1047 42.7952 31.2098 40.4317C31.3067 38.2341 31.6759 37.0475 31.9829 36.2564C32.3439 35.28 32.9151 34.3921 33.6716 33.6716C34.4004 32.9248 35.28 32.3536 36.255 31.9926C37.0461 31.6856 38.2424 31.3163 40.4303 31.2195C42.8035 31.1144 43.5158 31.0881 49.5194 31.0881C55.523 31.0881 56.2449 31.1144 58.6098 31.2195C60.8074 31.3163 61.994 31.6856 62.7851 31.9926C63.7601 32.3536 64.648 32.9248 65.3685 33.6716C66.1153 34.4018 66.6879 35.28 67.0475 36.2564C67.3545 37.0475 67.7238 38.2424 67.8206 40.4317C67.9257 42.8049 67.952 43.5172 67.952 49.5208C67.952 55.5243 67.9257 56.2283 67.8206 58.6015C67.7238 60.7991 67.3545 61.9857 67.0475 62.7768C66.291 64.7379 64.7351 66.2938 62.7754 67.0489C61.9843 67.3559 60.7894 67.7252 58.6001 67.822C56.2269 67.9271 55.5147 67.9533 49.5111 67.9533L49.5124 67.9547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5041 37.9421C43.1216 37.9421 37.9437 43.1201 37.9437 49.5026C37.9437 55.8852 43.1216 61.0631 49.5041 61.0631C55.8867 61.0631 61.0632 55.8852 61.0632 49.5026C61.0632 43.1201 55.8853 37.9421 49.5041 37.9421ZM49.5041 56.9999C45.3635 56.9999 42.0055 53.6419 42.0055 49.5012C42.0055 45.3605 45.3635 42.0026 49.5041 42.0026C53.6448 42.0026 57.0028 45.3605 57.0028 49.5012C57.0028 53.6419 53.6448 56.9999 49.5041 56.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2193 37.4859C64.2193 35.995 63.0105 34.7877 61.5196 34.7877C60.0288 34.7877 58.8214 35.9964 58.8214 37.4859C58.8214 38.9754 60.0302 40.1841 61.5196 40.1841C63.0091 40.1841 64.2193 38.9768 64.2193 37.4859Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_24_14",
    x: 9.60549,
    y: 44.54,
    width: 79.0423,
    height: 53.4964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.73,
    result: "effect1_foregroundBlur_24_14"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_24_14",
    x: 27,
    y: 27,
    width: 45,
    height: 45.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_24_14"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_24_14",
    x: 27,
    y: 27,
    width: 44.9198,
    height: 45.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_24_14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_14",
    x1: 8.40611,
    y1: 6.55022,
    x2: 82.6419,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDDE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24_14",
    x1: 49.1266,
    y1: 48.6734,
    x2: 49.1266,
    y2: 94.8077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E82D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A22DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643DCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24_14",
    x1: 49.8996,
    y1: 10.7004,
    x2: 49.8996,
    y2: 90.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E82D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A22DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643DCE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(27 27)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/InstagramIcon.d8e34bd4373a5096ebf186a27292ea7c.svg";
export { ForwardRef as ReactComponent };